import { render, staticRenderFns } from "./SuperAdminCommission.vue?vue&type=template&id=4a1d8d28&"
import script from "./SuperAdminCommission.vue?vue&type=script&lang=js&"
export * from "./SuperAdminCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports